import React from "react";
import { Link } from "react-router-dom";
import { FiPlus, FiEdit3 } from "react-icons/fi";
import "./PostPageHeader.css";

const PostPageHeader = ({
  title = "Shared Posts",
  description = "Browse community requests, service inquiries, customer requirements, and connect with potential clients and partners.",
  onOpenCreate,
  canCreate = true,
  totalCount,
  createLink = "/post/add-post",
}) => {
  return (
    <div className="post-page-header">
      <div className="post-page-header__content">
        <div className="post-page-header__badge">
          <FiEdit3 className="post-page-header__badge-icon" />
          <span>Post Hub</span>
          {typeof totalCount === "number" && (
            <span className="post-page-header__count-tag">{totalCount} Listed</span>
          )}
        </div>
        <h1 className="post-page-header__title">{title}</h1>
        <p className="post-page-header__description">{description}</p>
      </div>

      {canCreate && (
        <div className="post-page-header__actions">
          {onOpenCreate ? (
            <button
              type="button"
              className="post-page-header__create-btn"
              onClick={onOpenCreate}
            >
              <FiPlus size={18} />
              <span>Create Post</span>
            </button>
          ) : (
            <Link to={createLink} className="post-page-header__create-btn">
              <FiPlus size={18} />
              <span>Create Post</span>
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

export default PostPageHeader;
